export default __webpack_public_path__ + "img/cebiCdgy.16d64349.svg";